<template>
	<div class="key">
		<div class="row justify-content-center">
			<div class="col-11 col-lg-11">
				<div v-if="block.key_phrase" class="subtitle" v-html="block.key_phrase" />
			</div>
		</div>
	</div>
</template>

<script>
import panel from '~/mixins/panel';

export default {
	name: 'DraftKeyPhrase5fw',
	mixins: [panel],
};
</script>

<style lang="scss" scoped>
	@import "~/assets/styles/components/dev/draft-keyphrase-5";
</style>
